import ScrollMagic from "scrollmagic";
import FontFaceObserver from 'fontfaceobserver'
import {log} from "pusher-js";
import _, {functions} from "lodash";
import lozad from "lozad";
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import {is_desktop_small, is_mobile, is_desktop} from './utils'
import {
  updateFrames,
  perform_scene_easing,
  frame_cover_animation,
  grid_scale,
  city_lights_scroll,
  city_discover, city_belt_scroll, city_drop_scroll, city_family_scroll
} from './anime'
import {VideoSprite} from './video_sprites'
import {
  hydra_frame_options,
  siryon_colors_options,
  motor_options,
  battery_options,
  hydra_colors_options,
  bikeFrameOptionsSc,
  sc_frame_options
} from './seq'
import {frame_points} from './points'
import {top_parallax, bottom_parallax, parallax_scenes} from './parallax_gallery'
import {play_asist_video, play_suspension_video, set_main_video_position} from './video'
import {sub_menu} from "./sub_menu";
import {sticky_displays} from './sticky_displays';
import {mobile_nav} from './mobile_nav';
import {aos_btn_color} from './btn-color';
import {carbon_mask, flash_mask} from './masks';

const observer = lozad('.lozad', {
  rootMargin: '2000px 0px',
  threshold: 0.1,
  enableAutoReload: true,
  loaded: function () {
    ScrollTrigger.refresh(true);
    controller.update();
  }
});

observer.observe();

gsap.registerPlugin(ScrollTrigger)

const upd_seq = _.throttle(function (seq, data) {
  updateFrames(seq, data)
}, 16)

aos_btn_color();

flash_mask();
carbon_mask();
city_lights_scroll(headlight);

let isMain = false;
let ww = window.innerWidth;
let wh = window.innerHeight;
let isDesktop = ww >= 1280;
let isTablet = ww < 1280 && ww >= 768;
let scrollingScenes = [];
let isSmallDesktop = ww >= 1280 && ww < 1600;
let isFHD = ww >= 1600 && ww <= 1920;
let isLarge = ww > 1920;
let easeScenes = [];
let updateEasingScenes = true;
let controller = new ScrollMagic.Controller();
let bikeFrame;
let siryon_frame;
let sprites = [];
let motor;
let battery;
let colors;
let splits = [];
let headlight;
let belt;

let lightOptions = {
  baseURL: process.env.MIX_AWS_URL + "assets/images/city/L",
  ratio: 1920 / 1080,
  extension: ".jpg",
  frameCount: 172,
  firstFrame: "000.jpg",
  lastFrame: "Final.jpg",
  numberPadding: 3,
}

let beltOptions = {
  baseURL: process.env.MIX_AWS_URL + "assets/images/aryon-sc/belt/SC_BELT_",
  ratio: 16 / 9,
  extension: ".jpg",
  frameCount: 132,
  firstFrame: "000.jpg",
  lastFrame: "131.jpg",
  numberPadding: 3,
}

// Points for frame interactive
let points = {
  zero_in_p1: {
    from: 0,
    to: 0.1666
  },
  zero_in_p2: {
    from: 0.1766,
    to: 0.3333
  },
  zero_in_p3: {
    from: 0.3345,
    to: 0.5
  },
  p1_in_p2: {
    from: 0.5065,
    to: 0.6686
  },
  p1_in_p3: {
    from: 0.6655,
    to: 0.8353
  },
  p2_in_p3: {
    from: 0.8363,
    to: 1
  },
}

let canvasDensity = Math.min(2, window.devicePixelRatio);

gsap.defaults({
  ease: "linear",
  duration: 1,
  overwrite: "auto"
});

window.onload = function () {
  //If you don't want use timer and check innerHTML you can try this event
  isMain = document.querySelector(".main");

  // document.querySelector('.footer__text p').innerHTML = 'Specifications are subject to modifications due to supply chain circumstances, however the category and performance level will always be respected. If any provision (or part of any provision) of these Terms & Conditions is found to be illegal, invalid or unenforceable under any applicable law, such term shall, insofar as it is severable from the remaining terms, be deemed omitted from this agreement and shall in no way affect the legality, validity or enforceability of the remaining terms. 1. All Forestal bikes are fitted with an integrated SIM card and a free worldwide connectivity, providing access to all-time geolocation and geofence safety features, as well as factory-direct remote check and assistance services. 2. Some of the announced features, as well as more to come, will be made available through future updates.';

  let tempLink = document.createElement('a'),
    supportsAR = tempLink.relList.supports('ar');

  if (supportsAR) {
    $(".ar_icon, .ar_link").addClass("iOS");
  }

  if (!isMain) {
    return;
  }
  top_parallax(easeScenes, controller);
  if (is_desktop) {
    bottom_parallax(easeScenes, controller);
  }
  initSprites();
  adjustTabs();
  sticky_displays(controller, scrollingScenes);
  // powerScaleDown();
  city_lights_scroll(headlight);

  city_discover();
  city_belt_scroll(belt);
  city_drop_scroll(true);

  gsap.from('.your-race', {
    autoAlpha: 0,
    scrollTrigger: {
      trigger: '.your-race',
      start: 'top center',
      end: 'center center',
      scrub: true
    }
  })

  city_family_scroll();
  changeHeaderColor();
  light_toggle();
  lazyLoadContent();
  frame_points(points, siryon_frame);
  perform_scene_easing(updateEasingScenes, easeScenes);
  observeCanvasElements();
  // play_asist_video(controller, scrollingScenes);
  displayAssembly();
  // displayTextScroll();
  mobile_nav();

  citySuspensionScroll();

  if (is_desktop) {
    grid_scale();
    scrollMotorFrames();
    scrollBatteryFrames();
    motorBoxTextAnimation();
  }

  $(".main-display__background img").each(() => {
    if (this.complete) {
      setImage(this);
    } else {
      $(this).on("load", function () {
        setImage(this);
      })
    }
  });

  setTimeout(() => {
    setImage($(".main-display__background img")[0]);
  }, 500);


  let resizeTimer;
  // $(window).on('resize', () => {
  //   clearTimeout(resizeTimer);
  //   let widthChanged = ww !== window.innerWidth;
  //   ww = window.innerWidth;
  //   wh = window.innerHeight;
  //
  //   // let is_mobile = ww < 768 || wh < 491;
  //   isTablet = ww < 1280;
  //   isDesktop = ww >= 1280;
  //   isSmallDesktop = ww >= 1280 && ww < 1600;
  //   isFHD = ww >= 1600 && ww <= 1920;
  //   isLarge = ww > 1920;
  //
  //   if (widthChanged) {
  //     resizeTimer = setTimeout(function () {
  //       for (let i = 0; i < scrollingScenes.length; i++) {
  //         if (scrollingScenes[i].update) {
  //           scrollingScenes[i].update();
  //         }
  //       }
  //
  //       for (let i = 0; i < easeScenes.length; i++) {
  //         if (easeScenes[i].update) {
  //           easeScenes[i].update();
  //         }
  //       }
  //
  //       setImage($(".main-display__background img")[0]);
  //
  //       adjustTabs();
  //
  //       if (!is_mobile) {
  //         set_main_video_position();
  //       }
  //     }, 500);
  //   }
  // });

  sub_menu(updateEasingScenes);

  if (is_mobile) {
    scrollMobileMotor();
    navboxScrollEffect();
    return;
  }

  if (is_desktop) {
    // frame_cover_animation(controller, scrollingScenes);
    set_main_video_position();
  }
}

function loadContent() {
  if (!is_mobile) {
    var resizeTimer;
    var lastWidth = ww;
    $(window).on('resize', function (e) {
      clearTimeout(resizeTimer);
      var widthChanged = ww !== lastWidth;
      lastWidth = ww = window.innerWidth;
      wh = window.innerHeight;

      resizeTimer = setTimeout(function () {
        if (widthChanged) {
          recreateSplit();
        }
      }, 500);

    });

  }

  gsap.delayedCall(1, lazyLoadSprites);
}

function setImage(target) {
  let container = $(".main-display__display");
  let containerWidth = container.width();
  let containerHeight = container.height();
  gsap.set(".main-display__background", {
    top: 0,
    left: 0,
    immediateRender: true,
  })
  let backgroundContainerBox = document.querySelector(".main-display__background").getBoundingClientRect();
  let originalWidth = 100 * containerWidth / 12.78;
  let originalHeight = 100 * containerHeight / 17.97;
  let leftDistance = originalWidth / 100 * 44.51;
  let topDistance = originalHeight / 100 * 47.54;

  let bottomDistance = originalHeight / 100 * 34.49;
  let paddingBottom = wh - (wh * 0.2 + containerHeight);
  paddingBottom = is_mobile ? wh - (wh * 0.4 + containerHeight) : paddingBottom;
  paddingBottom = Math.min(bottomDistance, paddingBottom);

  gsap.set(".main-display__in", {
    paddingTop: topDistance / 1.5,
    paddingBottom: Math.min(300, bottomDistance),
    minHeight: containerHeight
  });


  let bgHeight = originalHeight + bottomDistance - paddingBottom;

  bgHeight = is_mobile ? originalHeight : bgHeight

  gsap.set(".main-display__background img", {
    top: 0,
    left: -leftDistance + backgroundContainerBox.left,
    width: originalWidth,
    height: originalHeight
  });

  gsap.set(".main-display__background", {
    top: -topDistance,
    left: -backgroundContainerBox.left,
    width: $(window).width(),
    height: bgHeight
  });

  gsap.set(target, {
    opacity: 1
  })
}

function adjustTabs() {
  if (!is_mobile) {
    let batteryHeadingHeight = 0
    let $batteryTabs = $(".battery__tabs h3");
    $batteryTabs.each(function (i, heading) {
      batteryHeadingHeight = Math.max(batteryHeadingHeight, $(heading).height());
    });
    $batteryTabs.height(batteryHeadingHeight);
  }

  $(".tabs__content").each(function (i, tab) {
    let maxHeight = 0;

    $(tab).find(".tab-pane").each(function (i, pane) {
      let newHeight = $(pane).height();
      maxHeight = maxHeight > newHeight ? maxHeight : newHeight;
    });

    $(tab).height(maxHeight).find(".tab-pan").height(maxHeight);

  });
}

// function getSprite(name) {
//     if (!sprites) return;
//     for (let i = 0; i < sprites.length; i++) {
//         if (sprites[i] && sprites[i].name === name) {
//             return sprites[i];
//         }
//     }
//
//     return null;
// }

function observeCanvasElements() {
  let spriteObserver = new IntersectionObserver((entries) => {
    entries.forEach(function (entry) {
      // let spriteName = $(entry.target).data("sprite");
      // let sprite = getSprite(spriteName);
      if (entry.isIntersecting) {
        for (let i = 0; i < easeScenes.length; i++) {
          if (easeScenes[i].isSprite) {
            easeScenes[i].follower.render(easeScenes[i].follower.time(), false, true);
          }
        }
      }
    });
  }, {
    root: null,
    rootMargin: "200px",
    threshold: 0
  });

  $("[data-sprite]").each(function (i, elem) {
    spriteObserver.observe(elem);
  });
}

function addEmptySpans() {
  $('.splitScroll span').each(function (i, elem) {
    let className = elem.className;
    let spanText = $(elem).text();
    let split = spanText.split(" ");
    let html = "";

    for (let i = 0; i < split.length; i++) {
      let text = split[i];
      html += "<span class='" + className + "' >" + text + "</span>";
      if (i !== split.length - 1)
        html += "<span class='empty'> </span>";
    }

    $(elem).replaceWith(html);
  });
}

function createSplitTimeline(elem) {
  let split = new SplitText(elem, {
    type: "lines, words",
    linesClass: "lines"
  });
  let spacing = []
  for (let j = 0; j < split.lines.length; j++) {
    spacing.push(j * 40);
  }
  let tl = gsap.timeline({})
    .fromTo(split.lines, {
      yPercent: gsap.utils.wrap(spacing),
      immediateRender: true
    }, {
      yPercent: 0,
      duration: 0.5,
      ease: "slow"
    });
  return {
    tl: tl,
    split: split
  };
}

function addSplit() {
  addEmptySpans();

  let paragraphs = $('.splitScroll');

  paragraphs.each(function (i, elem) {
    let splitObj = createSplitTimeline(elem);
    let tween = splitObj.tl;
    let split = splitObj.split;
    let scene = new ScrollMagic.Scene({
      triggerElement: elem,
      triggerHook: 0.8,
    })
      .setTween(tween)
      .addTo(controller)

    splits.push({
      tween: tween,
      split: split,
      scene: scene,
      elem: elem
    });
  });
}

function recreateSplit() {
  for (var i = 0; i < splits.length; i++) {
    var split = splits[i];
    var elem = split.elem;
    split.split.revert();
    var splitObj = createSplitTimeline(elem);
    split.split = splitObj.split;
    split.tween = splitObj.tl;

    try {
      split.scene.setTween(split.tween);
    } catch (e) {
    }

  }
}

function lazyLoadSprites() {

  let totalLoaded = 0;

  for (let i = 0; i < sprites.length; i++) {
    let videoSprite = sprites[i];
    if (videoSprite.videoLoaded) {
      totalLoaded++;
    } else {
      videoSprite.load(lazyLoadSprites);
      break;
    }
  }
}

function lazyLoadContent() {

  let imgObserver = new IntersectionObserver((entries) => {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.src = $(entry.target).data("src");
        if (entry.target.tagName === "video") entry.target.load();
        imgObserver.unobserve(entry.target);
      }
    });
  }, {
    root: null,
    rootMargin: "500px",
    threshold: 0
  });

  $("video[data-src],img[data-src]").each(function (i, elem) {
    imgObserver.observe(elem);
  });

  lazyLoadSprites()
}

function navboxScrollEffect() {
  let lastScrollTop = 0;
  let $window = $(window);
  let headerHeight = $(".header").height();

  let tl = gsap.timeline({
    paused: true,
    onReverseComplete: function () {
      gsap.delayedCall(3, function () {
        if ($window.scrollTop() > wh && !$(".header__burger").hasClass("is-animated")) {
          tl.play();
        }
      });
    }
  })
    .to(".header", {
      scaleY: 0,
      transformOrigin: "50% 0%",
      duration: 0.3,
      ease: "power2.inOut"
    })
    .to(".main__navbox", {
      y: -headerHeight,
      duration: 0.3,
      ease: "power2.inOut"
    }, 0)

  $window.on("scroll", function () {
    let st = $window.scrollTop();
    if (st > lastScrollTop && st > wh / 2 && updateEasingScenes) {
      tl.play();
    } else if (updateEasingScenes) {
      tl.reverse();
    }
    lastScrollTop = st;
  });
}

function changeHeaderColor() {
  const toggle_nav_color = () => {
    document.querySelector('.nav_menu').classList.toggle('dark_sub')
    document.querySelector('.header').classList.toggle('dark')
  }

  const dark = document.querySelectorAll(".footer");
  dark.forEach(s => {
    let blackScene = new ScrollMagic.Scene({
      triggerElement: s,
      triggerHook: 1
    })
      .on("enter", function () {
        toggle_nav_color()
      })
      .on("leave", function () {
        toggle_nav_color()
      })
      .addTo(controller);
  });
}

const light_toggle = () => {
  gsap.from('.light_mask', .25, {
    opacity: 0,
    scrollTrigger: {
      trigger: '.city_light_types .type_2',
      start: 'top 85%',
      end: 'top+=10px 85%',
      scrub: .1
    }
  })
}

function designScaleDown() {
  let designBackground = document.querySelector(".main-design__background");
  let tween = gsap.to({}, {})
  let follower = gsap.timeline({
    paused: true
  })

    .fromTo(designBackground, {
      scale: 1
    }, {
      scale: function () {
        let scale = isSmallDesktop ? 0.9 : 0.8;
        scale = isTablet ? 1 : scale;
        return scale;
      }
    });

  let scene = new ScrollMagic.Scene({
    triggerElement: ".main-design__heading",
    triggerHook: 0.5,
    duration: "70%"
  })
    .setTween(tween)
    .addTo(controller)

  easeScenes.push({
    tween: tween,
    follower: follower,
    scene: scene,
    update: function () {
      follower.invalidate();
      follower.render(follower.time(), false, true);
    }
  });
}

function powerScaleDown() {
  let sceneDuration = 0.6;
  let triggerHook = 0;
  let scaleDown = gsap.fromTo(".main-power__background", {
    scale: 1
  }, {
    scale: function () {
      let scale = 1;
      if (isDesktop) scale = 0.8;
      if (isSmallDesktop) scale = 0.9;
      return scale;
    },
    duration: 0.3
  })

  let powerTextTl = gsap.timeline({})
    .to(".main-power__gradient", {
      yPercent: -33.33,
      duration: 0.3
    }, 'translateIn')
    .from(".main-power__heading", {
      yPercent: 100,
      duration: 0.3
    }, 'translateIn')

  let tween = gsap.to({}, {
    duration: 0.3
  });

  let follower = gsap.timeline({
    paused: true
  })
    .add(scaleDown)
    .add(powerTextTl, 0)

  let scene = new ScrollMagic.Scene({
    triggerElement: ".main-power",
    duration: "60%"
  })
    .setTween(tween)
    .addTo(controller)

  let easingScene = {
    tween: tween,
    follower: follower,
    scene: scene,
    update: function () {
      let height = $(".main-power__sticky").height();
      triggerHook = Math.max(0, (wh / 2 - height / 2) / wh);
      scene.triggerHook(triggerHook)
      gsap.set(".main-power__sticky", {
        top: wh * triggerHook
      })
      $(".main-power").height(height + wh * sceneDuration);

      scaleDown.invalidate();
      follower.render(follower.time(), false, true);
    }
  }
  easeScenes.push(easingScene)
  easingScene.update();
}

function scrollMobileMotor() {
  let obj = {
    value: 0
  };

  let tween = gsap.to({}, {})
  let follower = gsap.timeline({
    paused: true,
    onUpdate: function () {
      updateFrames(motor, obj);
    }
  })
    .to({}, {})
    .to(obj, {
      value: 0,
      duration: 0.1
    }, 0)
    .to(obj, {
      value: 1,
      duration: 0.8,
    }, 0.1)
    .to(obj, {
      value: 1,
      duration: 0.1
    });

  let scene = new ScrollMagic.Scene({
    triggerElement: ".main-motor__image",
    triggerHook: 0.8,
    duration: "60%"
  })
    .setTween(tween)
    .addTo(controller)

  easeScenes.push({
    tween: tween,
    follower: follower,
    scene: scene,
    isSprite: true,
    sprite: "motor"
  });
}

function scrollMotorFrames() {
  let obj = {
    value: 0
  };

  let tween = gsap.to({}, {})
  let follower = gsap.timeline({
    paused: true,

    onUpdate: function () {
      updateFrames(motor, obj);
    }
  })
    .to(obj, {
      value: 0,
      duration: 0.02
    }, 0)
    .to(obj, {
      value: 1,
      duration: 0.98,
    }, 0.02)
    .to(obj, {
      value: 1,
      duration: 0.1
    })
    .to("#motorOverlay", {
      opacity: 0.8,
      duration: 0.5
    }, 1)
    .from(".main-motor .main-motor__specs_wrapper", {
      yPercent: 100
    }, 0.5)
    .from(".main-motor .specs__col", {
      yPercent: 150,
      delay: (i) => {
        return 0.2 * ((i % 4) + 1)
      },
      duration: 0.5
    }, 0.5)
    .to({}, {
      duration: 0.05
    });

  let scene = new ScrollMagic.Scene({
    triggerElement: ".main-motor__image",
    triggerHook: 0,
    duration: "150%"
  })
    .setPin(".main-motor__image")
    .setTween(tween)
    .addTo(controller)

  easeScenes.push({
    tween: tween,
    follower: follower,
    scene: scene,
    isSprite: true,
    sprite: "motor"
  })

}

function motorBoxTextAnimation() {
  let duration = $(".motor-box__wrapper").height();
  let tween = gsap.to({}, {})
  let follower = gsap.timeline({
    paused: true
  })

    .fromTo(".main-motor-box.one .main-motor-box__image", {
      yPercent: 20,
      immediateRender: true
    }, {
      yPercent: -20
    })

    .fromTo(".main-motor-box.two .main-motor-box__image", {
      yPercent: 20,
      immediateRender: true
    }, {
      yPercent: -20
    }, 0.3)

  let scene = new ScrollMagic.Scene({
    triggerElement: ".main-motor-box.one",
    triggerHook: 0.5,
    duration: duration
  })
    .setTween(tween)
    .addTo(controller)

  easeScenes.push({
    tween: tween,
    follower: follower,
    scene: scene,
    update: function () {
      scene.duration($(".motor-box__wrapper").height());
    }
  });

  $(".motor-box__wrapper img").each(function () {
    if (this.complete) {
      scene.duration($(".motor-box__wrapper").height());
    } else {
      $(this).on("load", function () {
        scene.duration($(".motor-box__wrapper").height());
      })
    }
  });
}

function scrollBatteryFrames() {
  let obj = {
    value: 0
  };
  let tween = gsap.to({}, {})
  let follower = gsap.timeline({
    paused: true,
    onUpdate: function () {
      updateFrames(battery, obj);
    }
  })
    .to({}, {})
    .to(obj, {
      value: 0,
      duration: 0.1
    }, 0)
    .to(obj, {
      value: 1,
      duration: 0.8,
    }, 0.1)
    .to(obj, {
      value: 1,
      duration: 0.1
    })
    .from(".main-battery__specs", {
      yPercent: 100,
      stagger: 0.2,
      duration: 0.4
    }, 1)
    .from(".main-battery .specs__col", {
      yPercent: 100,
      stagger: 0.2,
      duration: 0.4
    }, 1)
    .to({}, {
      duration: 0.03
    });
  let scene = new ScrollMagic.Scene({
    triggerElement: ".main-battery__image",
    triggerHook: 0,
    duration: "150%"
  })
    .setPin(".main-battery__image")
    .setTween(tween)
    .addTo(controller);

  easeScenes.push({
    tween: tween,
    follower: follower,
    scene: scene,
    isSprite: true,
    sprite: "battery"
  })
}

function displayTextScroll() {
  let displayScreens = $(".display_screen");
  let changeImage = gsap.timeline();
  let stickyWrapper = $(".main-display__sticky_wrapper");
  gsap.set(displayScreens, {
    opacity: 0
  })
  gsap.set(displayScreens[0], {
    opacity: 1
  })
  displayScreens.each(function (i, elem) {
    changeImage.to(elem, {
      ease: "steps(1)",
      opacity: 1
    });
    changeImage.to({}, {
      duration: 2
    });
  });

  let tween = gsap.timeline()
  tween.add(changeImage);

  let scene = new ScrollMagic.Scene({
    triggerElement: document.querySelector('.main-display__features')
  })
    .setTween(tween)
    .addTo(controller)

  let scrollingScene = {
    tween: tween,
    scene: scene,
    update: function () {
      let text = document.querySelector(".main-display__features ul")
      let display = document.querySelector(".main-display__display")
      let textBox = text.getBoundingClientRect();
      let displayBox = display.getBoundingClientRect();
      let push = Math.max(0, textBox.height - displayBox.height);
      stickyWrapper.height(push + displayBox.height);
      let triggerHook = ($(".header").height() + $(".main__navbox").height() + 10) / wh;
      triggerHook = is_mobile ? 0.4 : triggerHook;
      gsap.set(display, {
        top: triggerHook * wh
      });
      scene.triggerHook(triggerHook);
      scene.duration(push);
    }
  }
  scrollingScenes.push(scrollingScene);
  scrollingScene.update();
}

function displayAssembly() {
  let boxImages = $('.main-display-info__image.original img').toArray().reverse();
  let triggerHook = is_mobile ? 1 : 1;
  let tween = gsap.to({}, {})
  let specsAssembly = gsap.timeline({
    paused: true
  })
    .from(boxImages, {
      yPercent: 150,
      duration: 1,
      delay: function (i) {
        if (i > boxImages.length - 2) {
          return (boxImages.length - 1) * 0.25;
        } else {
          return (i + 1) * 0.25;
        }
      }
    }, 'specs')
  let follower = gsap.timeline({
    paused: true
  })
    .to({}, {
      duration: 0.1
    })
    .from('.main-display-info_dots', {
      yPercent: 100
    }, 'specs')
    .from('.main-display-info__specs', {
      yPercent: 300
    }, 'specs')
    .from('.main-display-info__image.original', {
      yPercent: 300
    }, 'specs')
    .to(specsAssembly, {
      progress: 1,
      duration: 5,
      ease: "slow( 0.7, 1, false)"
    }, 'specs')
    .from('.main-display-info__specs li', {
      opacity: 0,
      stagger: 0.1
    }, '-=0.5')
    .to({}, {
      duration: 0.1
    });

  let scene = new ScrollMagic.Scene({
    triggerElement: '.main-display-info',
    triggerHook: triggerHook,
    duration: '90%'
  })
    .setTween(tween)
    .addTo(controller)

  easeScenes.push({
    tween: tween,
    follower: follower,
    scene: scene
  })
}

function initSprites() {
  if (!is_mobile && $(".main__video video").length) {
    var mainVideoPlayed = false;
    var mainVideoLoaded = false;
    var main_video = $('.main__video video');
    var mainVideoIsPlaying = false;
    var playVideoTimer;
    var autoPlayAttempts = 0;
    var bikeTitleAnimation = gsap.fromTo(".main__bike", {
      yPercent: 100,
      opacity: 1
    }, {
      yPercent: 0,
      paused: true,
      duration: 1.2,
      ease: "power2.out"
    });
    var videoSource = main_video.find("source").data("src");
    main_video.attr("src", videoSource);
    main_video[0].load();
    // if video is cached then directly play video
    if (main_video[0].readyState === 4) {
      main_video[0].play();
    } else {
      // adds event to play video when it is ready
      main_video.on("canplaythrough", function () {
        if (mainVideoLoaded) return;
        mainVideoLoaded = true;
        main_video[0].play();
      });
    }

    // once video is done playing, check if font has loaded
    main_video[0].addEventListener("ended", function () {
      if (mainVideoPlayed) return;
      mainVideoPlayed = true;
      var tl = gsap.timeline()

        .set(".main__video img", {
          display: "block",
          position: "absolute",
          opacity: 1
        })
        .to(main_video, {
          display: "none",
          opacity: 0,
          duration: 5
        })
        .set(".main__video img", {
          display: "block",
          position: "relative",
          opacity: 1
        })
      loadContent();
    });
    main_video[0].addEventListener("timeupdate", function () {
      if (main_video[0].currentTime >= 6) {
        bikeTitleAnimation.play();
      }
    });

    main_video[0].addEventListener("playing", function () {
      mainVideoIsPlaying = true;
    });


    playVideoTimer = setInterval(function () {
      autoPlayAttempts++;
      if (!mainVideoPlayed && main_video[0].readyState === 4 && !mainVideoIsPlaying) {
        main_video[0].play();
      } else if (mainVideoPlayed) {
        clearInterval(playVideoTimer);
      }

      if (autoPlayAttempts > 7 && !mainVideoIsPlaying) {
        clearInterval(playVideoTimer);
        gsap.timeline()
          .set(main_video, {
            display: "none"
          })
          .fromTo(".main__video img", {
            opacity: 0,
            display: "block"
          }, {
            display: "block",
            opacity: 1
          })
          .add(bikeTitleAnimation.play());
        loadContent();
      }
    }, 2000);

  } else {
    loadContent();
  }

  belt = new VideoSprite({
    name: "belt",
    container: document.querySelector(".belt-canvas"),
    backgroundColor: 0x000000,
    parent: document.querySelector(".carbon-mask")
  }, beltOptions);

  sprites.push(belt);

  bikeFrame = new VideoSprite({
    name: "frame",
    container: document.querySelector(".frame-canvas-rotate"),
    backgroundColor: 0xffffff,
    parent: document.querySelector(".frame-canvas-rotate")
  }, bikeFrameOptionsSc);

  sprites.push(bikeFrame);

  siryon_frame = new VideoSprite({
    name: "geometry",
    container: document.querySelector(".main-frame__image"),
    backgroundColor: 0xffffff,
    parent: document.querySelector(".main-frame__image")
  }, sc_frame_options);

  sprites.push(siryon_frame);

  motor = new VideoSprite({
    name: "motor",
    container: document.querySelector(".main-motor__image"),
    backgroundColor: 0x000000,
    parent: document.querySelector(".main-motor__image .canvas-wrapper")
  }, motor_options);

  sprites.push(motor);

  headlight = new VideoSprite({
    name: "headlight",
    container: document.querySelector(".headlight-canvas"),
    backgroundColor: 0xFFFFFF,
    parent: document.querySelector(".headlight-canvas")
  }, lightOptions);

  sprites.push(headlight);

  if (!is_mobile) {
    battery = new VideoSprite({
      name: "battery",
      container: document.querySelector(".main-battery__image"),
      backgroundColor: 0x000000
    }, battery_options);

    sprites.push(battery);

    var font = new FontFaceObserver('Object Sans', {
      weight: 700
    });

    // once font is loaded, starts loading frames
    font.load(null, 10000).then(function () {
      addSplit();
    }, function () {
      console.log("failed to load font");
      addSplit();
    });
  }
}


function citySuspensionScroll() {
  let obj = {
    value: 0
  }

  ScrollTrigger.create({
    trigger: "#frame-canvas-rotate",
    start: "top bottom",
    end: "bottom top",
    scrub: .5,
    onUpdate: self => {
      gsap.to(obj, {
        value: self.progress.toFixed(3),
        duration: 0.2,
        onUpdate: () => {
          upd_seq(bikeFrame, obj)
        }
      })
    },
  })
}
